import React from 'react';
import { string, bool } from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import setFieldData from 'final-form-set-field-data';
import classNames from 'classnames';
import {
  Form,
  PrimaryButton,
  FieldTextInput,
  IconEnquiry,
  FieldReviewRating,
} from '../../components';
import { required } from '../../util/validators';
import { propTypes } from '../../util/types';

import css from './LeaveOffPlatformReviewForm.css';

const LeaveOffPlatformReviewFormComponent = props => {
  const { displayName, leaveOffPlatformReviewError } = props;

  return (
    <FinalForm
      {...props}
      mutators={{ setFieldData }}
      render={fieldRenderProps => {
        const {
          rootClassName,
          className,
          formId,
          handleSubmit,
          inProgress,
          intl,
          values,
        } = fieldRenderProps;

        const leaveTestimonialInstructions1 = (
          <FormattedMessage
            id="LeaveOffPlatformReviewForm.leaveTestimonialInstructions1"
            values={{
              displayName: displayName,
              b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
            }}
          />
        );
        const leaveTestimonialInstructions2 = intl.formatMessage({
          id: 'LeaveOffPlatformReviewForm.leaveTestimonialInstructions2',
        });

        const reviewRatingLabel = intl.formatMessage({
          id: 'LeaveOffPlatformReviewForm.reviewRatingLabel',
        });

        const fieldRequired = intl.formatMessage({ id: 'FieldRequired.fieldRequired' });

        const authorNameLabel = intl.formatMessage({
          id: 'LeaveOffPlatformReviewForm.authorNameLabel',
        });

        const authorNamePlaceholder = intl.formatMessage({
          id: 'LeaveOffPlatformReviewForm.authorNamePlaceholder',
        });

        const contentLabel = intl.formatMessage({
          id: 'LeaveOffPlatformReviewForm.contentLabel',
        });

        const contentPlaceholder = intl.formatMessage({
          id: 'LeaveOffPlatformReviewForm.contentPlaceholder',
        });

        const errorMessage = leaveOffPlatformReviewError ? (
          <p className={css.error}>
            <FormattedMessage id="LeaveOffPlatformReviewForm.error" />
          </p>
        ) : null;

        const classes = classNames(rootClassName || css.root, className);
        const submitInProgress = inProgress;
        const submitDisabled = submitInProgress;

        return (
          <Form className={classes} onSubmit={handleSubmit}>
            <IconEnquiry className={css.icon} />

            <div>
              <article className={css.instructions}>
                <p>{leaveTestimonialInstructions1}</p>
                <p>{leaveTestimonialInstructions2}</p>
              </article>
              <FieldReviewRating
                className={css.reviewRating}
                id={formId ? `${formId}.reviewRating` : 'reviewRating'}
                name="reviewRating"
                label={reviewRatingLabel}
                validate={required(fieldRequired)}
              />
              <FieldTextInput
                className={css.field}
                type="textarea"
                name="authorName"
                id={formId ? `${formId}.authorName` : 'authorName'}
                label={authorNameLabel}
                placeholder={authorNamePlaceholder}
                validate={required(fieldRequired)}
              />
              <FieldTextInput
                className={css.fieldContent}
                type="textarea"
                name="content"
                id={formId ? `${formId}.content` : 'content'}
                label={contentLabel}
                placeholder={contentPlaceholder}
                validate={required(fieldRequired)}
              />
              <div className={css.submitButtonContainer}>
                {errorMessage}
                <PrimaryButton
                  className={css.submitButton}
                  type="submit"
                  inProgress={submitInProgress}
                  disabled={
                    submitDisabled || !values.reviewRating || !values.authorName || !values.content
                  }
                >
                  <FormattedMessage id="LeaveOffPlatformReviewForm.submitButtonText" />
                </PrimaryButton>
              </div>
            </div>
          </Form>
        );
      }}
    />
  );
};

LeaveOffPlatformReviewFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  submitButtonWrapperClassName: null,
  inProgress: false,
  sendEnquiryError: null,
};

LeaveOffPlatformReviewFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  submitButtonWrapperClassName: string,

  inProgress: bool,

  sendEnquiryError: propTypes.error,

  // from injectIntl
  intl: intlShape.isRequired,
};

const LeaveOffPlatformReviewForm = compose(injectIntl)(LeaveOffPlatformReviewFormComponent);

LeaveOffPlatformReviewForm.displayName = 'LeaveOffPlatformReviewForm';

export default LeaveOffPlatformReviewForm;
